import moment   from 'moment';
import {fullYear, priceView} from "@utilities/functions";



moment.locale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'Son_Mon_Die_Mit_Don_Fre_San'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
});

export const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

export const defaultAddConditionText = function (state, condition) {
    return '';
};

export const defaultConditions = function (state) {
    const offerdate = new Date();
    offerdate.setDate(offerdate.getDate() + 30);

    const startAt = moment(state.order.startAt, 'DD.MM.YYYY');
    const endAt = moment(state.order.endAt, 'DD.MM.YYYY');


    let conditions = [];
    conditions['de_DE'] = [
        {
            category: 'Angebotsoption',
            subcategory: 'zum Paketpreis:',
            days: null,
            conditionText: '',
            type: 'date',
            key: `${+ new Date}-offer-1`,
            deadlineDate: offerdate.toLocaleDateString('de-DE'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 14,
            conditionText: 'Zahlung des Rechnungsbetrages',
            type: 'days',
            key: `${+ new Date}-payment-2`,
            deadlineDate: startAt.clone().subtract(14, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            afterDays: 10,
            conditionText: 'Zahlung des Rechnungsbetrages',
            type: 'afterDays',
            key: `${+ new Date}-payment-1`,
            deadlineDate: endAt.clone().add(10, 'days').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 60,
            conditionText: 'kostenfrei',
            type: 'days',
            key: `${+ new Date}-cancelation-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 28,
            conditionText: '30% des Paketpreises',
            type: 'days',
            key: `${+ new Date}-cancelation-2`,
            deadlineDate: startAt.clone().subtract(28, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 14,
            conditionText: '50% des Paketpreises',
            type: 'days',
            key: `${+ new Date}-cancelation-3`,
            deadlineDate: startAt.clone().subtract(14, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 7,
            conditionText: '75% des Paketpreises',
            type: 'days',
            key: `${+ new Date}-cancelation-4`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 6,
            conditionText: '95% des Paketpreises',
            type: 'days',
            key: `${+ new Date}-cancelation-5`,
            deadlineDate: startAt.clone().subtract(6, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
    ];
    conditions.fr = [
        {
            category: 'Angebotsoption',
            subcategory: 'zum Paketpreis:',
            days: null,
            conditionText: '',
            type: 'date',
            key: `${+new Date()}-offer-1`,
            deadlineDate: offerdate.toLocaleDateString('de-DE'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 60,
            conditionText: '15% Anzahlung vom Paketpreis',
            type: 'days',
            key: `${+new Date()}-payment-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 7,
            conditionText: 'Zahlung des Gesamtpreises',
            type: 'days',
            key: `${+new Date()}-payment-2`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 60,
            conditionText: 'kostenfrei',
            type: 'days',
            key: `${+new Date()}-cancelation-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 28,
            conditionText: '15% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-2`,
            deadlineDate: startAt.clone().subtract(28, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 14,
            conditionText: '30% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-3`,
            deadlineDate: startAt.clone().subtract(14, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 7,
            conditionText: '50% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-4`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 6,
            conditionText: '100% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-5`,
            deadlineDate: startAt.clone().subtract(6, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
    ];

    conditions.en = [
        {
            category: 'Angebotsoption',
            subcategory: 'zum Paketpreis:',
            days: null,
            conditionText: '',
            type: 'date',
            key: `${+new Date()}-offer-1`,
            deadlineDate: offerdate.toLocaleDateString('de-DE'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 60,
            conditionText: '15% Anzahlung vom Paketpreis',
            type: 'days',
            key: `${+new Date()}-payment-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 7,
            conditionText: 'Zahlung des Gesamtpreises',
            type: 'days',
            key: `${+new Date()}-payment-2`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 60,
            conditionText: 'kostenfrei',
            type: 'days',
            key: `${+new Date()}-cancelation-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 28,
            conditionText: '15% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-2`,
            deadlineDate: startAt.clone().subtract(28, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 14,
            conditionText: '30% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-3`,
            deadlineDate: startAt.clone().subtract(14, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 7,
            conditionText: '50% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-4`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 6,
            conditionText: '100% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-5`,
            deadlineDate: startAt.clone().subtract(6, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
    ];

    if (!state.order.orderLocale || !conditions[state.order.orderLocale]) {
        state.order.orderLocale = 'de_DE';
    }

    return conditions[state.order.orderLocale];
};

export const defaultFreeplaces = function () {
    return [
        {
            freePlaces: 1,
            numberOfPersons: 21,
            type: 'double',
            key: 1
        },
        {
            freePlaces: 1,
            numberOfPersons: 42,
            type: 'double',
            key: 2
        }
    ];
};

export const defaultOrderContingent = function () {
    return {
        hotelContingent: {
            single: '5',
            double: '20'
        },
        ferryContingent: {
            singleCabins: '0',
            doubleCabins: '0'
        },
    };
};

export const defaultHotelPlaceholderValues = {
        hotelType: {category: "", stars: "3"},
        board:     'half',
    defaultHotelTimes: [
        { type: 'dinner', time: '20:00:00', firstNightOnly: false},
        { type: 'checkIn', time: '18:00:00', firstNightOnly: true },
        { type: 'checkIn', time: '00:00:00' , firstNightOnly: false },
        { type: 'breakfast', time: '07:30:00', firstNightOnly: false}
    ],
};

export const defaultOtherPlaceholderValues = {
    otherServiceType: '/api/other_service_types/676',
};

export const defaultDayValues = {
    isAutomaticName:     false,
    //addDayWithoutForm: true,
};

export const defaultClientInvoiceValues= function (locale) {
    let introText = {
        'de_DE':    '<p>nachfolgend übersende ich die Rechnung für folgende Fahrt:</p>',
        'fr':       '<p>Je vous envoie ci-dessous la facture du voyage suivant</p>',
        'en':       '<p>I am sending you the invoice for the following journey</p>'
    };

    return {
        type: 'normal',
        percent: '',
        invoiceDate: null,
        dueDate: null,
        addressing: 'formal',
        introText: introText[locale],
        calculationBasis: '',
        introEndText: '',
        amountType: 'amount',
        taxPercentage: 0.0,
        showTax: true,
    }
}

export const defaultEmailTags = [
        { id: 1, name: 'Kunde Anfrage', class: '', icon: 'person_outline' },
        { id: 2, name: 'Kunde Angebot', class: '', icon: 'person_outline' },
        { id: 3, name: 'Kunde Absage', class: '', icon: 'person_outline' },
        { id: 4, name: 'Kunde Reservierung', class: '', icon: 'person_outline' },
        { id: 5, name: 'Kunde Auftragsbestätigung', class: '', icon: 'person_outline' },
        { id: 6, name: 'Kunde Buchungsstand', class: '', icon: 'person_outline' },
        { id: 7, name: 'Kunde Zimmerliste', class: '', icon: 'person_outline' },
        { id: 8, name: 'Kunde Rechnung', class: '', icon: 'person_outline' },
        { id: 9, name: 'Kunde Stornierung', class: '', icon: 'person_outline' },
        { id: 10, name: 'Kunde Allgemein', class: '', icon: 'person_outline' },
        { id: 11, name: 'Hotel Anfrage', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 12, name: 'Hotel Angebot', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 13, name: 'Hotel refus', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 14, name: 'Hotel Option', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 15, name: 'Hotel Absage', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 16, name: 'Hotel Reservierung', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 17, name: 'Hotel Rückbestätigung', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 18, name: 'Hotel Buchungsstand', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 19, name: 'Hotel Resa unsicher', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 20, name: 'Hotel Zimmerliste', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 21, name: 'Hotel Menü', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 22, name: 'Hotel Menüauswahl gesendet', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 23, name: 'Hotel Rechnung', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 24, name: 'Hotel Stornierung', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 25, name: 'Hotel Allgemein', class: 'is-blue-strong', icon: 'local_hotel' },
        { id: 26, name: 'Zusatzleistung Anfrage', class: '', icon: 'more_horiz' },
        { id: 27, name: 'Zusatzleistung Angebot', class: '', icon: 'more_horiz' },
        { id: 28, name: 'Zusatzleistung refus', class: '', icon: 'more_horiz' },
        { id: 29, name: 'Zusatzleistung Option', class: '', icon: 'more_horiz' },
        { id: 30, name: 'Zusatzleistung Absage', class: '', icon: 'more_horiz' },
        { id: 31, name: 'Zusatzleistung Reservierung', class: '', icon: 'more_horiz' },
        { id: 32, name: 'Zusatzleistung Rückbestätigung', class: '', icon: 'more_horiz' },
        { id: 33, name: 'Zusatzleistung Buchungsstand', class: '', icon: 'more_horiz' },
        { id: 34, name: 'Zusatzleistung Rechnung', class: '', icon: 'more_horiz' },
        { id: 35, name: 'Zusatzleistung Stornierung', class: '', icon: 'more_horiz' },
        { id: 36, name: 'Zusatzleistung Allgemein', class: '', icon: 'more_horiz' },
    ];

export const defaultRoomListTypes = [
    {
        value: 'hotel_short',
        name: 'Hotels (Word)'
    },
    {
        value: 'hotel_pdf',
        name: 'Hotels (PDF)'
    },
    {
        value: 'hotel_excel_buspaket',
        name: 'Buspaket'
    },
];

export const defaultRoomListPage = {
    type: 'hotel_pdf'
};

export const clientInvoiceIntroEndText = function (form, oldInvoiceId, currency) {
    const { amount, type, partialAmount } = form;
    const dueDate = fullYear(form.dueDate);

    let text = ''
    currency = currency === 'EUR' ? '€' : '';


    if(oldInvoiceId){
        text += '<p>Diese Rechnung ersetzt alle unter dieser Rechnungsnummer vor obigem Rechnungsdatum erstellten Rechnungen.</p>';
    }
    if(type === 'prepayment') {
        text += oldInvoiceId ? '<p><br>' : '<p>';
        text += 'Wir bitten um eine Anzahlung in Höhe von ' + priceView(partialAmount) + ' ' + currency + '.</p>';
    }
    if(amount < 0) {
        text += oldInvoiceId ? '<p><br>' : '<p>';
        text += 'Wir werden Ihnen den zu viel bezahlten Betrag in den nächsten Tagen zurückerstatten.</p>';
    }

    return text;
};

export const clientInvoiceIntroText = function (form, oldInvoiceId, currency) {
    return '';
};

export const defaultTripDetailGenerateSettings = {
    _route: true,
    _generalInfos: true,
    _questionaire: false,
    print: false,
};

export const defaultItemPrice = {
    name: 'Zuschlag',
    quantityType: 'per_person',
    limitType: 'validIfLimit',
    quantity: null,
    billingType: 'included',
    inCalculation: true,
};

export const defaultConceptClientId = 4715;

export const otherTypesExcluded = [
    'financial',
];
export const defaultTags = {
    hotels: [
        'Hotel im Stadtzentrum',
        'Hotel am Stadtrand',
        'Hotel außerhalb',
        'Hotel im Gewerbegebiet',
        'Strandhotel',
        'Strandnähe',
        'Klimaanlage',
        'Minibar',
        'Safe',
        'Deutsches TV',
        'Schwimmbad (innen)',
        'Schwimmbad (außen)',
        'Spa',
        'Fahrstuhl',
        'Restaurant',
        'Bar'
    ]
};

export const additionalProviderProperties = [
    {
        additionalIdentifier: 'organisation-1',
        name: 'Kundennummer Welcometours',
        value: '',
    },
    {
        additionalIdentifier: 'organisation-2',
        name: 'Kundennummer Eurobintrading',
        value: '',
    },
];

export const driverRoomType = null;
export const driverCabinType = null;

export const defaultUserDashboardFilters = function () {
    return {
        isRequests: true,
        type: 'orders',

        // Filters
        _search: '',
        tripName: '',
        users: [],

        hotel: {
            destination: null
        },
        ferry: {
            startPort: null,
            endPort: null,
        },
        train: {
            startTrainStation: null,
            endTrainStation: null,
        },
        airline: {
            startAirport: null,
            endAirport: null
        },
        other: {
            otherServiceTypeCategory: null,
        },

        // Orders
        destinations: [],
        country: null,
        organisation: null,
        durationDays: null,

        // Request
        agency: null,
        orderStatus: [],
        startAt: null,
        endAt: null,
        requestStatus: [],
        traitTags: [],

        // Placeholder
        notRequestStatus: null,
        clientOfferStatus: null,
        location: {
            area: null,
            destination: null
        },
    }
}
